export const frontmatter = {
  category: 'guia',
  title: 'Que faut-il emporter pour Ilha do Mel : Liste complète 2026',
  excerpt: 'N\'oubliez rien lors de votre voyage à Ilha do Mel. Liste complète des indispensables, des choses inutiles et conseils des locaux pour un voyage léger et sans souci.',
  publishedAt: '2026-04-23',
  author: 'Guia Ilha do Mel',
  tags: ['checklist', 'dicas-praticas', 'o-que-levar'],
  coverImage: '/images/hero-bg.jpg',
  readingTime: '5 min',
};

Que faut-il emporter pour Ilha do Mel ? Liste complète

L'île de Mel est une destination sans voitures, sans distributeurs automatiques et avec des infrastructures limitées. **Voyager léger et bien préparé** fait toute la différence entre un voyage sans encombre et une succession de contretemps.

Cette liste de vérification a été compilée à partir des conseils de résidents et de personnes qui s'y sont rendues des dizaines de fois.

---

Avant de quitter la maison

Documents

- [ ] Carte d'identité nationale (RG ou CNH, document avec photo)

- [ ] Preuve de réservation en chambre d'hôtes

- [ ] Espèces (PIX fonctionne, mais le réseau est instable)

- [ ] Carte bancaire (pour les urgences à Paranaguá/Pontal)

**Conseil local :** Prévoyez au moins 300 à 500 R$ en espèces pour un séjour de 2 à 3 jours. Presque aucun kiosque n’accepte les cartes bancaires.

---

Vêtements et chaussures

| Article | Quantité | Remarque |

| ---------------------- | ---------- | ----------------------------------------------- |

| Maillot de bain | 2-3 | Ne sèche pas rapidement à cause de l'humidité de l'île |

| Serviette de plage | 1 | Légère et peu encombrante en microfibre |

| T-shirts légers | 3-4 | Coton ou tissu technique |

| Shorts | 2-3 | Pour la randonnée et la plage |

| Pantalon léger | 1 | Pour la randonnée et les soirées fraîches |

| Sweat-shirt/veste légère | 1 | Venté la nuit, même en été |

| Tongs | 1 paire | Pour tous les jours sur le sable |

| Chaussures de randonnée | 1 paire | **Indispensables** pour la randonnée (ne pas porter de sandales) |

| Chapeau/casquette | 1 | Protection solaire indispensable |

| Lunettes de soleil | 1 paire | Protection UV |

---

Hygiène et santé

- [ ] Crème solaire **SPF 50+** (le soleil se reflète sur le sable et provoque davantage de coups de soleil)

- [ ] Répulsif anti-moustiques

- [ ] Crème hydratante après-soleil

- [ ] Shampoing et savon (la maison d'hôtes n'en fournit peut-être pas)

- [ ] Brosse à dents et dentifrice

- [ ] Médicaments contre le mal de mer (les traversées en bateau peuvent être agitées)

- [ ] Antalgiques (dipyrone/paracétamol)

- [ ] Pansements et antiseptique

- [ ] Préservatifs (il n'y a pas de pharmacies sur l'île)

**Attention :** Il n’y a pas de pharmacie sur l’Ilha do Mel. Apportez tous les médicaments dont vous pourriez avoir besoin.

---

Électronique

- [ ] Chargeur de téléphone portable + batterie externe

- [ ] Écouteurs (l'île est calme, profitez-en)

- [ ] Appareil photo (facultatif, le paysage s'y prête)

- [ ] Lampe torche ou téléphone portable avec lampe torche (les rues ne sont pas éclairées la nuit)

- [ ] Adaptateur secteur (à vérifier auprès de la maison d'hôtes)

---

À la plage

- [ ] Masque de plongée (facultatif – l'eau est cristalline)

- [ ] Petite glacière (pour l'eau et les en-cas)

- [ ] Gourde réutilisable

- [ ] Sac réutilisable (il n'y a pas de sacs plastiques sur l'île)

- [ ] Livre/liseuse (la plage invite à la déconnexion)

---

Ce qu'il ne faut PAS apporter

| Objet | Pourquoi le laisser à la maison ? |

| --------------------- | ---------------------------------------------------- |

| Valise à roulettes | Rues sablonneuses et rocailleuses — vous la porterez sur le dos |

| Sèche-cheveux | L'électricité est précieuse et peu de maisons d'hôtes en sont équipées |

| Ustensiles de cuisine | Il n'y a pas de cuisine commune — mangez au restaurant |

| Vêtements de luxe | Environnement rustique et sable omniprésent |

| Tickets restaurant/VR | Non acceptés |

---

Sac à dos ou valise : lequel choisir ?

**Un sac à dos est la meilleure option.** Sans exception.

Il n'y a pas de voitures sur l'île : vous porterez tout sur votre dos.

Les chemins de sable, de pierres et de terre rendent les valises à roulettes inutilisables.

La traversée en bateau vous obligera à porter vos affaires jusqu'à la maison d'hôtes.

**Règle d'or :** si vous ne pouvez pas le porter seul sur 1 km de sentier, ne le prenez pas.

---

Liste de contrôle rapide pour 2 jours

```
☐ RG + reserva da pousada
☐ R$ 300-500 em espécie
☐ 2 biquínis + 3 camisetas + 2 shorts
☐ Tênis de trilha + chinelo
☐ Protetor solar FPS 50 + repelente
☐ Power bank + carregador
☐ Remédios básicos
☐ Mochila (não mala!)
```

---

Dernier conseil : voyagez léger.

L'île de Mel récompense ceux qui voyagent léger. Moins de bagages = plus de liberté pour explorer les sentiers, gravir le phare et flâner d'un village à l'autre sans être encombré.

Vous souhaitez savoir comment vous rendre à l'Ilha do Mel, où loger et combien cela coûte ? Notre guide complet de l'Ilha do Mel propose des itinéraires clés en main, des budgets adaptés à différents profils et des conseils d'habitants pour vous aider à organiser le voyage idéal.